import { notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useState } from 'react';
import { useCreateEducationClassMutation } from 'shared/api';
import type { EducationClassFormValues } from 'entities/education-class/form';

export const useCreateEducationClass = () => {
  const [form] = useForm<EducationClassFormValues>();

  const [createEducationClass, { isLoading }] = useCreateEducationClassMutation();

  const [visible, setVisible] = useState(false);

  const [creationMode, setCreationMode] = useState<'single' | 'multiple'>('single');

  const onSubmit = () => {
    form.validateFields().then((values) => {
      createEducationClass({
        ...values,
        includeSaturday: values.includeSaturday ?? false,
        saturdayMorningShift: values.saturdayMorningShift ?? false,
      })
        .unwrap()
        .then(() => {
          hideModal();
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось создать класс' });
          throw error;
        });
    });
  };

  const showModal = (mode: 'single' | 'multiple') => {
    setCreationMode(mode);
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    form.resetFields();
  };

  return {
    state: {
      form,
      isLoading,
      visible,
      creationMode,
    },
    methods: {
      onSubmit,
      showModal,
      hideModal,
    },
  };
};
